import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FilterControlComponent, FilterControl, FilterControlOptions } from './filter-control';

@Component({
  template: `
    <glxy-form-field [bottomSpacing]="'none'" [formGroup]="formGroup">
      <glxy-label *ngIf="control.label">{{ control.label | translate }}</glxy-label>
      <span matPrefix *ngIf="control.prefix">{{ control.prefix }} &nbsp;</span>
      <input type="number" matInput [formControl]="control" [min]="0" />
      <span matSuffix *ngIf="control.suffix">&nbsp; {{ control.suffix }}</span>
    </glxy-form-field>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberInputFilterControlComponent implements FilterControlComponent {
  control: NumberInputFilterControl;
  formGroup: UntypedFormGroup;
}

export class NumberInputFilterControl extends FilterControl {
  component = NumberInputFilterControlComponent;

  constructor(
    public name: string,
    public label?: string,
    public prefix?: string,
    public suffix?: string,
    formState?: any,
    opts: FilterControlOptions = {},
  ) {
    super(name, label, formState, opts);
  }
}
